import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const foecheckinadvApi = api
  .enhanceEndpoints({ addTagTypes: ['FOECheckinAdv'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOECheckinAdvs: builder.query<
        (fo_echeckin & fo_echeckinadvance & fo_eaddrbook  & {roomnos: string})[],
        string
      >({
        query: cid => `foecheckinadv/${cid}`,
        providesTags: ['FOECheckinAdv']
      }),
      getFOECheckinAdvById: builder.query<fo_echeckinadvance, string>({
        query: id => `foecheckinadv/byid/${id}`,
        providesTags: ['FOECheckinAdv']
      }),
      getFOECheckinAdvByRooms: builder.query<any, any>({
        query: checkins => `foecheckinadv/byrooms/${checkins.toString()}`,
        providesTags: ['FOECheckinAdv']
      }),
      insertFOECheckinAdv: builder.mutation({
        query: foecheckinadv => ({
          url: `foecheckinadv/`,
          method: 'POST',
          body: foecheckinadv
        }),
        invalidatesTags: ['FOECheckinAdv']
      }),
      updateFOECheckinAdv: builder.mutation({
        query: foecheckinadv => ({
          url: `foecheckinadv/`,
          method: 'PUT',
          body: foecheckinadv
        }),
        invalidatesTags: ['FOECheckinAdv']
      }),
      deleteFOECheckinAdv: builder.mutation({
        query: foecheckinadv => ({
          url: `foecheckinadv/${foecheckinadv.ca_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOECheckinAdv']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOECheckinAdvsQuery,
  useGetFOECheckinAdvByIdQuery,
  useGetFOECheckinAdvByRoomsQuery,
  useInsertFOECheckinAdvMutation,
  useUpdateFOECheckinAdvMutation,
  useDeleteFOECheckinAdvMutation
} = foecheckinadvApi;

